import * as React from "react";

const ExportIcon: React.FC = () => {
    return (
        <svg
            fill="#0071AD"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
            xmlSpace="preserve"
        >
            <path d="M20 24H0V0h14.41L20 5.59v4.38h-2V8h-6V2H2v20h18v2zM14 6h3.59L14 2.41V6zm4.71 14.71L17.3 19.3l2.29-2.3H11v-2h8.59l-2.29-2.29 1.41-1.41 4.7 4.7-4.7 4.71z" />
        </svg>
    );
};
export default React.memo(ExportIcon);
